"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var factorySvgIcon_1 = __importDefault(require("./utils/factorySvgIcon"));
var SvgBadgeFilled = function (props) {
    var color = props.color;
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19 9A7 7 0 1 1 5 9a7 7 0 0 1 14 0Zm-7.493-3.566a.55.55 0 0 1 .986 0l.837 1.696a.05.05 0 0 0 .038.027l1.87.272a.55.55 0 0 1 .306.938l-1.354 1.32a.05.05 0 0 0-.015.044l.32 1.864a.55.55 0 0 1-.798.58l-1.674-.88a.05.05 0 0 0-.046 0l-1.674.88a.55.55 0 0 1-.798-.58l.32-1.864a.05.05 0 0 0-.014-.044l-1.354-1.32a.55.55 0 0 1 .305-.938l1.87-.272a.05.05 0 0 0 .038-.027l.837-1.696Z", fill: color }),
        React.createElement("path", { d: "M7 21v-4.516A8.958 8.958 0 0 0 12 18c1.85 0 3.57-.558 5-1.516V21a1 1 0 0 1-1.351.936L12 20.568l-3.649 1.368A1 1 0 0 1 7 21Z", fill: color })));
};
exports.default = factorySvgIcon_1.default(SvgBadgeFilled);
//# sourceMappingURL=SvgBadgeFilled.js.map